/**
 * Created by CertiSur on 17/12/2016.
 */

//====================----------------=====================
// ALISON WEB
//====================----------------=====================

var configWebOPTIONS = {
    "../config/alison-config.distro.json?dummy": "Desktop Distro (P+D+T)",
    "../config/alison-config.update.json?dummy": "Desktop Update (D+T+P)",
    "../test/config/1.1.2/alison-config.distro.json?dummy": "Desktop Distro (1.1.2)",
    ".": "------ Desktop -------v",
    "../test/config/alison-config.desktop_d.json?dummy": "Desktop D",
    "../test/config/alison-config.desktop_t.json?dummy": "Desktop T",
    "../test/config/alison-config.desktop_p.json?dummy": "Desktop P",
    "../test/config/alison-config.desktop_t-desktop_p.json?dummy": "Desktop T + Desktop P",
    "..": "------ Server -------v",
    "../test/config/alison-config.server_p.json?dummy": "Server P",
    "../test/config/alison-config.server_d.json?dummy": "Server D",
    "../test/config/alison-config.server-multiple.json?dummy": "Server Multiple",
    "...": "------ Mixed --------v",
    "../test/config/alison-config.desktop_d-server_d.json?dummy": "Desktop D + Server D",
    ".....": "------ Clients -------v",
    "../test/config/alison-config.santanderrio.json?dummy": "Desktop SantanderRio",
    "../test/config/alison-config.banval.json?dummy": "Desktop Banco de Valores"
};

//====================----------------=====================
// DEBBIE
//====================----------------=====================

var debbieServerOPTIONS = {
    "http://localhost:8002"             :  "http://locahost:8002",
    "https://pilot-debbie.certisur.com" :  "https://pilot-debbie.certisur.com",
    "http://pilot-debbie.certisur.com"  :  "http://pilot-debbie.certisur.com",
    "http://colt.verisur:8002"          :  "http://colt.verisur:8002",
    "https://debbie.certisur.com:4443"  :  "https://debbie.certisur.com:4443",
    "https://debbie0.certisur.com:4443"  :  "https://debbie0.certisur.com:4443",
    "https://debbie1.certisur.com:4443"  :  "https://debbie1.certisur.com:4443",
    "https://debbie2.certisur.com:4443"  :  "https://debbie2.certisur.com:4443",
    "https://debbie3.certisur.com:4443"  :  "https://debbie3.certisur.com:4443"
};


var debbiePolicyOPTIONS = {
    "authbureau.pilot"          :  "PILOT CertiSur Authentication Bureau",
    "banval.utf-8.pilot"        :  "PILOT Banco de Valores UTF-8",
    "banval.iso-8859-1.pilot"   :  "PILOT Banco de Valores ISO-8859-1",
    "santanderrio.pilot"        :  "PILOT Banco Santander Rio",
    "bolsas.pilot"              :  "PILOT Bolsas",
    "certinet.pilot"            :  "PILOT CertiNet",
    "authbureau.pilot"          :  "PILOT CertiSur Authentication Bureau",
    "certinet"                  :  "PROD CertiNet",
    "santander"                 :  "PROD Banco Santander Rio"
};

var signatureTypeOPTIONS = {
    "NONE"                 :    "NONE",
    "PKCS1"                 :   "PKCS1",
    "CAdES"                 :   "CAdES",
    "XAdES-Enveloping"      :   "XAdES-Enveloping",
    "XAdES-Enveloped"       :   "XAdES-Enveloped",
    "XAdES-Detached"        :   "XAdES-Detached",
    "XMLDSig"               :   "XMLDSig",
    "XMLDSig-Enveloping"    :   "XMLDSig-Enveloping",
    "XMLDSig-Enveloped"     :   "XMLDSig-Enveloped",
    "XMLDSig-Detached"      :   "XMLDSig-Detached",
    "XMLDSig-SignedInfo"    :   "XMLDSig-SignedInfo",
    "PAdES"                 :   "PAdES"
};

var algorithmOPTIONS = {
    "SHA256withRSA"                 :   "SHA256withRSA",
    "SHA1withRSA"                 :   "SHA1withRSA",
    "SHA512withRSA"               :   "SHA512withRSA"
};

var signatureTypeValOPTIONS = {
    "CAdES"                 :   "CAdES",
    "XAdES"                 :   "XAdES",
    "XMLDSig"               :   "XMLDSig",
    "PAdES"                 :   "PAdES",
    "P7B"                   :   "P7B"
};

var signedTextPackValOPTIONS = {
    ""                      :   "None",
    "BASE64"                :   "BASE64 (file)",
    "BASE64-ISO-8859-1"     :   "BASE64-ISO-8859-1",
    "BASE64-UTF-8"          :   "BASE64-UTF-8"
};

var signatureValidateOPTIONS = {
    "CAdES"                 : "CAdES",
    "XAdES"                 : "XAdES",
    "PAdES"                 : "PAdES"
};


var sampleContentTypeOPTIONS = {
    "text/html"  : "HTML",
    "text/plain" : "TXT",
    "text/xml"   : "XML"
};

//====================----------------=====================
// ALISON GEN
//====================----------------=====================

var configGenOPTIONS = {
    "../config/alison-config.distro.json?dummy": "Desktop Distro (D+T+P)",
    ".": "------ Desktop -------v",
    "../test/config/alison-config.desktop_d.json?dummy": "Desktop D",
    "../test/config/alison-config.desktop_t.json?dummy": "Desktop T",
    "../test/config/alison-config.desktop_p.json?dummy": "Desktop P",
    "../test/config/alison-config.desktop_t-desktop_p.json?dummy": "Desktop T + Desktop P"
};

var keystoresOPTIONS = {
    "WIN-ENH":"Microsoft Enhanced",
    "CSK": "CSK",
    "ETOKEN": "EToken",
    "MTOKEN": "MToken",
    "MACOS": "MacOS Keychain",
    "FF-NSS": "Firefox NSS",
    "YUBIKEY": "Yubico",
    "EPASS": "Feitian ePass",
    "ATHE-PIV": "Athena PIV",
    "PFX": "PFX file",
    "": "Empty"
};

var keystoreSelectorOPTIONS = {
    "": "Seleccionar Keystore",
    "keystoreid": "KeyStoreId Solo",
    "{\"keyStoreId\" : \"ETOKEN\", \"profileName\" : \"COMPLETAR_CON_EL_PROFILE_NAME\" }":"EToken",
    "{\"keyStoreId\" : \"MTOKEN\", \"profileName\" : \"COMPLETAR_CON_EL_PROFILE_NAME\" }":"MToken",
    "{\"keyStoreId\" : \"CSK\", \"profileName\" : \"COMPLETAR_CON_EL_PROFILE_NAME\" }":"CSK",
    "{\"keyStoreId\" : \"CSK\", \"profileName\" : \"-New-\" }":"CSK Nuevo",
    "{\"keyStoreId\" : \"PFX\", \"profileName\" : \"-New-\" }":"PFX Nuevo"
};

var uContextOPTIONS = {
    "": "Select  UContext",
    "{{\"userId\" : \"jorge\", \"enabledProviders\" : [\"alison-desktop-d\",\"alison-desktop-t\",\"alison-desktop-p\"] }" : "Ejemplo 1",
    "{{\"userId\" : \"acarrata\", \"userChannel\" : \"SantanderId\", \"enabledKeystores\" : [\"CSK\",\"ETOKEN\",\"CSK-SRV\"], \"enabledProviders\" : [\"alison-desktop-d\",\"alison-desktop-t\",\"alison-desktop-p\"] }" : "Santander"
};

var securityPolicyCAPI = {
    "{}" : "No Policy",
    "{\"exportable\": true,\"protectionLevel\": 0,\"description\": \"John Doe - Lev0 - Exportable\",\"friendlyName\": \"Sign and Authenticate services\",\"title\": \"Digital Certificate\" }" : "Level 0, exportable",
    "{\"exportable\": false,\"protectionLevel\": 0,\"description\": \"John Doe - Lev0 - NoExportable\",\"friendlyName\": \"Sign and Authenticate services\",\"title\": \"Digital Certificate\" }" : "Level 0, no exportable",
    "{\"exportable\": true,\"protectionLevel\": 1,\"description\": \"John Doe - Lev1 - Exportable\",\"friendlyName\": \"Sign and Authenticate services\",\"title\": \"Digital Certificate\" }" : "Level 1, exportable",
    "{\"exportable\": false,\"protectionLevel\": 1,\"description\": \"John Doe - Lev1 - NoExportable\",\"friendlyName\": \"Sign and Authenticate services\",\"title\": \"Digital Certificate\" }" : "Level 1, no exportable",
    "{\"exportable\": true,\"protectionLevel\": 2,\"description\": \"John Doe - Lev2 - Exportable\",\"friendlyName\": \"Sign and Authenticate services\",\"title\": \"Digital Certificate\" }" : "Level 2, exportable",
    "{\"exportable\": false,\"protectionLevel\": 2,\"description\": \"John Doe - Lev2 - NoExportable\",\"friendlyName\": \"Sign and Authenticate services\",\"title\": \"Digital Certificate\" }" : "Level 2, no exportable",
    "{\"capiSecPolicy\": { \"mask\": \"0x00000000\" }}" : "Legacy CAPI no exportable no password",
    "{\"capiSecPolicy\": { \"mask\": \"0x00000001\" }}" : "Legacy CAPI exportable no password",
    "{\"capiSecPolicy\": { \"mask\": \"0x00000002\" }}" : "Legacy CAPI no exportable suggest password",
    "{\"capiSecPolicy\": { \"mask\": \"0x00000003\" }}" : "Legacy CAPI exportable suggest password",
    "{\"capiSecPolicy\": { \"mask\": \"0x00000004\" }}" : "Legacy CAPI no exportable force password",
    "{\"capiSecPolicy\": { \"mask\": \"0x00000005\" }}" : "Legacy CAPI exportable force password",
}

var securityPolicyCSK = {
    "{}" : "No Policy",
    "{\"id\": \"polIdv-0-0-0-0-0-0-0\",      \"passComplexity\" : 0,\"passMinLength\" : 0,  \"passExpiration\" : 0,  \"passLockCount\" : 0,  \"lockTimeout\" : 0, \"idleTimeout\" : 0,  \"certExport\" : 0}": "CSK 0-0-0-0-0-0-0",
    "{\"id\": \"polIdv-2-6-10-12-4-15-1\",   \"passComplexity\" : 2,\"passMinLength\" : 6,  \"passExpiration\" : 10, \"passLockCount\" : 12, \"lockTimeout\" : 4, \"idleTimeout\" : 15, \"certExport\" : 1}": "CSK 2-6-10-12-4-15-1",
    "{\"id\": \"polIdv-3-8-0-10-0-3-2\",     \"passComplexity\" : 3,\"passMinLength\" : 8,  \"passExpiration\" : 0,  \"passLockCount\" : 10, \"lockTimeout\" : 0, \"idleTimeout\" : 3,  \"certExport\" : 2}": "CSK 3-8-0-10-0-3-2",
    "{\"id\": \"polIdv-1-7-36-6-5-3-4\",     \"passComplexity\" : 1,\"passMinLength\" : 7,  \"passExpiration\" : 36, \"passLockCount\" : 6,  \"lockTimeout\" : 5, \"idleTimeout\" : 3,  \"certExport\" : 4}": "CSK 1-7-36-6-5-3-4",
    "{\"id\": \"polIdv-4-9-33-3-8-6-8\",     \"passComplexity\" : 4,\"passMinLength\" : 9,  \"passExpiration\" : 33, \"passLockCount\" : 3,  \"lockTimeout\" : 8, \"idleTimeout\" : 6,  \"certExport\" : 8}": "CSK 4-9-33-3-8-6-8",
    "{\"id\": \"polIdv-2-5-60-15-3-0-10\",   \"passComplexity\" : 2,\"passMinLength\" : 5,  \"passExpiration\" : 60, \"passLockCount\" : 1,  \"lockTimeout\" : 3, \"idleTimeout\" : 0,  \"certExport\" : 10}": "CSK 2-5-60-15-3-0-10",
    "{\"id\": \"polIdv-3-8-365-10-15-10-15\",\"passComplexity\" : 3,\"passMinLength\" : 8,  \"passExpiration\" : 365,\"passLockCount\" : 10, \"lockTimeout\" : 15,\"idleTimeout\" : 10, \"certExport\" : 15}": "CSK 3-8-365-10-15-10-15",
}

var securityPolicyDEVICE = {
    "{}" : "No Policy",
    "{\"installDummy\": \"true\", \"generateOnBoard\": \"true\"}" : "InstallDummmy, generaOnBoard",
    "{\"installDummy\": \"false\", \"generateOnBoard\": \"true\"}" : "Not InstallDummmy, generaOnBoard",
    "{\"installDummy\": \"true\", \"generateOnBoard\": \"false\"}" : "InstallDummmy, Not generaOnBoard",
    "{\"installDummy\": \"false\", \"generateOnBoard\": \"false\"}" : "Not InstallDummmy, Not generaOnBoard",
    "---" : "-----------",
    "{\"modelTemplate\": \"RIJKSPAS-default\"}" : "RIJKSPAS-default",
    "{\"modelTemplate\": \"RIJKSPAS-protected\"}" : "RIJKSPAS-protected",
    "{\"modelTemplate\": \"RIJKSPAS-qsign\"}" : "RIJKSPAS-qsign",
    "----" : "-----------",
    "{\"modelTemplate\": \"YUBIKEY-default\"}" : "YUBIKEY-default",
    "{\"modelTemplate\": \"YUBIKEY-digital-signature\"}" : "YUBIKEY-digital-signature",
    "{\"modelTemplate\": \"YUBIKEY-card-authentication\"}" : "YUBIKEY-card-authentication",
    "{\"modelTemplate\": \"YUBIKEY-key-management\"}" : "YUBIKEY-key-managementt",
    "{\"modelTemplate\": \"YUBIKEY-authentication\"}" : "YUBIKEY-authentication",
}

var securityPolicyEMPTY = {
    "{}" : "No Policy",
}


var securityPolicyPFX = {
    "{}" : "No Policy",
    "{\"passSecPolicy\": { }}" : "Pass default",
    "{\"passSecPolicy\": { \"passComplexity\" : 0,\"passMinLength\" : 0 }}": "Pass 0-0",
    "{\"passSecPolicy\": { \"passComplexity\" : 2,\"passMinLength\" : 5 }}": "Pass 2-5",
    "{\"passSecPolicy\": { \"passComplexity\" : 4,\"passMinLength\" : 8 }}": "Pass 4-8",
}

var securityPolicyOPTIONS = {
    "{}" : "No Policy",
    "{\"capiSecPolicy\": { \"mask\": \"0x00000000\" }}" : "CAPI -exportable -protected",
    "{\"capiSecPolicy\": { \"mask\": \"0x00000001\" }}" : "CAPI +exportable -protected",
    "{\"capiSecPolicy\": { \"mask\": \"0x00000002\" }}" : "CAPI -exportable +protected",
    "{\"capiSecPolicy\": { \"mask\": \"0x00000003\" }}" : "CAPI +exportable +protected",

    "{\"etokenSecPolicy\": { }}" : "EToken default",
    "{\"etokenSecPolicy\": { \"installDummy\": \"false\" }}" : "EToken in Memory",
    "{\"etokenSecPolicy\": { \"installDummy\": \"true\" }}" : "EToken installDummmy",

    "{\"mtokenSecPolicy\": { }}" : "MToken default",
    "{\"mtokenSecPolicy\": { \"installDummy\": \"true\", \"generateOnBoard\": \"true\", \"passComplexity\" : 2,\"passMinLength\" : 6 }}" : "MToken +GenOnBoard +InstallDummy 2,6",
    "{\"mtokenSecPolicy\": { \"installDummy\": \"true\", \"generateOnBoard\": \"false\", \"passComplexity\" : 3,\"passMinLength\" : 7 }}" : "MToken -GenOnBoard +InstallDummy 3,7",
    "{\"mtokenSecPolicy\": { \"installDummy\": \"false\", \"generateOnBoard\": \"false\", \"passComplexity\" : 1,\"passMinLength\" : 8 }}" : "MToken -GenOnBoard -InstallDummy 1,8",

    "{\"passSecPolicy\": { }}" : "Pass default",
    "{\"passSecPolicy\": { \"passComplexity\" : 0,\"passMinLength\" : 0 }}": "Pass 0-0",
    "{\"passSecPolicy\": { \"passComplexity\" : 2,\"passMinLength\" : 5 }}": "Pass 2-5",
    "{\"passSecPolicy\": { \"passComplexity\" : 4,\"passMinLength\" : 8 }}": "Pass 4-8",

    "{\"cskSecPolicy\": {\"id\": \"polIdv-0-0-0-0-0-0-0\",      \"passComplexity\" : 0,\"passMinLength\" : 0,  \"passExpiration\" : 0,  \"passLockCount\" : 0,  \"lockTimeout\" : 0, \"idleTimeout\" : 0,  \"certExport\" : 0}}": "CSK 0-0-0-0-0-0-0",
    "{\"cskSecPolicy\": {\"id\": \"polIdv-2-6-10-12-4-15-1\",   \"passComplexity\" : 2,\"passMinLength\" : 6,  \"passExpiration\" : 10, \"passLockCount\" : 12, \"lockTimeout\" : 4, \"idleTimeout\" : 15, \"certExport\" : 1}}": "CSK 2-6-10-12-4-15-1",
    "{\"cskSecPolicy\": {\"id\": \"polIdv-3-8-0-10-0-3-2\",     \"passComplexity\" : 3,\"passMinLength\" : 8,  \"passExpiration\" : 0,  \"passLockCount\" : 10, \"lockTimeout\" : 0, \"idleTimeout\" : 3,  \"certExport\" : 2}}": "CSK 3-8-0-10-0-3-2",
    "{\"cskSecPolicy\": {\"id\": \"polIdv-1-7-36-6-5-3-4\",     \"passComplexity\" : 1,\"passMinLength\" : 7,  \"passExpiration\" : 36, \"passLockCount\" : 6,  \"lockTimeout\" : 5, \"idleTimeout\" : 3,  \"certExport\" : 4}}": "CSK 1-7-36-6-5-3-4",
    "{\"cskSecPolicy\": {\"id\": \"polIdv-4-9-33-3-8-6-8\",     \"passComplexity\" : 4,\"passMinLength\" : 9,  \"passExpiration\" : 33, \"passLockCount\" : 3,  \"lockTimeout\" : 8, \"idleTimeout\" : 6,  \"certExport\" : 8}}": "CSK 4-9-33-3-8-6-8",
    "{\"cskSecPolicy\": {\"id\": \"polIdv-2-5-60-15-3-0-10\",   \"passComplexity\" : 2,\"passMinLength\" : 5,  \"passExpiration\" : 60, \"passLockCount\" : 1,  \"lockTimeout\" : 3, \"idleTimeout\" : 0,  \"certExport\" : 10}}": "CSK 2-5-60-15-3-0-10",
    "{\"cskSecPolicy\": {\"id\": \"polIdv-3-8-365-10-15-10-15\",\"passComplexity\" : 3,\"passMinLength\" : 8,  \"passExpiration\" : 365,\"passLockCount\" : 10, \"lockTimeout\" : 15,\"idleTimeout\" : 10, \"certExport\" : 15}}": "CSK 3-8-365-10-15-10-15",
};



export { 
    configWebOPTIONS, 
    debbieServerOPTIONS, 
    debbiePolicyOPTIONS, 
    signatureTypeOPTIONS, 
    signatureTypeValOPTIONS,
    signedTextPackValOPTIONS,
    signatureValidateOPTIONS,
    sampleContentTypeOPTIONS,
    configGenOPTIONS,
    keystoresOPTIONS,
    keystoreSelectorOPTIONS,
    uContextOPTIONS,
    securityPolicyEMPTY,
    securityPolicyCAPI,
    securityPolicyCSK,
    securityPolicyDEVICE,
    securityPolicyPFX,
    algorithmOPTIONS,

    securityPolicyOPTIONS
 };